<template>
  <div>
    <div>
      Statuses:
      <v-layout>
        <v-flex xs1>
          <v-switch v-model="statuses" label="Draft" value="Draft"/>
        </v-flex>
        <v-flex xs1>
          <v-switch v-model="statuses" label="Checked" value="Checked"/>
        </v-flex>
        <v-flex xs1>
          <v-switch v-model="statuses" label="Charged" value="Charged"/>
        </v-flex>
        <v-flex xs1>
          <v-switch v-model="statuses" label="Paid" value="Paid"/>
        </v-flex>
      </v-layout>
    </div>

    <div>
      <clients-select v-model="clientIds"/>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import ClientsSelect from '../../../components/Ui/mcc/ClientsSelect'

  export default {
    name: 'invoices-list-filter',
    components: {
      ClientsSelect,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        filter: state => state.invoices.filter
      }),
      clientIds: {
        get() {
          return this.filter.clientIds
        },
        set(newValue) {
          this.invoicesChangeFilter({
            clientIds: newValue
          })
        }
      },
      statuses: {
        get() {
          return this.filter.statuses
        },
        set(newValue) {
          this.invoicesChangeFilter({
            statuses: newValue
          })
        }
      }
    },
    methods: {
      ...mapActions({
        invoicesChangeFilter: 'invoicesChangeFilter',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoicesListFilter.vue